export const UNIT_VS = 'Unit vs.';
export const PRACTICE_CHARACTERIZATION = 'Practice Characterization';
export const AGGREGATE_PERCENTAGE = 'Aggregate Percentage';
